var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative fixed-top"},[_c('Banner'),_c('div',{staticClass:"flex"},[_c('b-card',{staticClass:"w-4/12 shadow-xl bg-white",attrs:{"no-body":""}},[_c('Contacts')],1),_c('div',{staticClass:"w-8/12 px-1"},[_c('b-card',{attrs:{"no-body":""}},[_c('Messages')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }